// #======================================#
// #     _____       _ _       _  _       #
// #    |  __ \     (_) |     | || |      #
// #    | |__) |__ _ _| |___  | || |_     #
// #    |  _  // _` | | / __| |__   _|    #
// #    | | \ \ (_| | | \__ \    | |      #
// #    |_|  \_\__,_|_|_|___/    |_|      #
// #                                      #
// #======================================#

//I18n.translate("admin_auctioneer_" ,{default: "aaa", param: "hello", ... })
var I18n = {};

I18n.CURRENCY_TO_SYMBOL = {
  EUR: '€',
  USD: '$',
  GBP: '£'
};

I18n.translate = function(key,params) {
    var value = TRANSLATIONS[key];
    if (value === null || typeof value === "undefined") {
      if (params && params['default']) {
        value = params['default'];
      }
      else {
        return "translation missing: "+key;
      }
    }
    return value.replace(/%\{(.*?)\}/g,function (match,param_name) { return params[param_name];} );
};

I18n.extend = function(locale, translations) {
  return translations;
}

// Same interface as in i18n-js;
I18n.defaultLocale = 'nl'; // Keep behaviour of old `I18n.current_locale()` if we cannot guess any locale

// We skip <body data-locale> here because for English it contains the local variation (i.e. "en-GB"),
// and that breaks a lot of things.
I18n.locale = (document.body && document.body.getAttribute('data-lang')) || (document.documentElement.getAttribute('lang') || 'en').replace('de', 'du');

I18n.currentLocale = function() {
  return I18n.locale || I18n.defaultLocale;
}

I18n.current_locale = function () {
  if (document.domain.indexOf('dev') !== -1) {
    // Trace old usages, and nudge the developers into the right direction
    console.warn('`I18n.current_locale()` is deprecated. Please use `I18n.currentLocale()`');
  }

  return I18n.currentLocale();
};

I18n.format_amount_in_euros = function (amount,locale) {
  locale = locale || I18n.current_locale();
  return I18n.format_amount_in_currency(amount, 'EUR', locale, { 'prependCurrencySymbol' : true });
};

I18n.format_amount_in_euros_decimals = function (amount,locale) {
  locale = locale || I18n.current_locale();
  return I18n.format_amount_in_currency_decimals(amount, 'EUR', locale, { 'prependCurrencySymbol' : true });
};

I18n.format_amount_in_currency = function (amount, currencyCode, locale, options) {
  if (!options) {
    options = {};
  }
  var currencySymbol = I18n.CURRENCY_TO_SYMBOL[currencyCode] || currencyCode;
  var prefix = currencySymbol + " ";
  var amount_integer = String(parseInt(amount,10));
  switch(locale || I18n.current_locale()) {
    case "nl": amount_integer = I18n.number_format(amount_integer, ",", ".", "."); break;
    case "en": amount_integer = I18n.number_format(amount_integer, ".", ",", ","); break;
    case "du": amount_integer = I18n.number_format(amount_integer, ",", ".", " "); break;
    case "fr": amount_integer = I18n.number_format(amount_integer, ",", " ", " "); break;
  }
  if (options.prependCurrencySymbol) {
    return prefix + amount_integer;
  } else {
    return amount_integer;
  }
};

I18n.format_amount_in_currency_decimals = function (amount, currencyCode, locale, options) {
  if (!options) {
    options = {};
  }
  var prefix = currencyCode + " ";
  var amount_float = String(amount.toFixed(2));
  switch(locale || I18n.current_locale()) {
    case "nl": amount_float = I18n.number_format(amount_float, ",", ".", "."); break;
    case "en": amount_float = I18n.number_format(amount_float, ".", ",", ","); break;
    case "du": amount_float = I18n.number_format(amount_float, ",", ".", " "); break;
    case "fr": amount_float = I18n.number_format(amount_float, ",", " ", " "); break;
  }
  if (options.prependCurrencySymbol) {
    return prefix + amount_float;
  } else {
    return amount_float;
  }
};

I18n.number_format = function (nStr, dec_point, first_thousands_sep,thousands_sep) {
    nStr += '';
    var x = nStr.split(".");
    var x1 = x[0];
    var x2 = x.length > 1 ? dec_point + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    if (rgx.test(x1)) {
      // console.log("match",x1);
      x1 = x1.replace(rgx, '$1' + first_thousands_sep + '$2');
    }

    while (rgx.test(x1)) {
      // console.log("match",x1);
      x1 = x1.replace(rgx, '$1' + thousands_sep + '$2');
    }

    return x1 + x2;
};



/*
  returns an array of day names for the current locale, or, if not there: english.
  the index of the array items matches values returned from date.getDay()
*/
I18n.day_names = function () {
  var day_names = {
    "nl": ["Zondag","Maandag","Dinsdag","Woensdag","Donderdag","Vrijdag","Zaterdag"],
    "en": ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]
  };
  if (day_names[I18n.current_locale()]) {
    return day_names[I18n.current_locale()];
  }
  else {
    return day_names.en;
  }
};
